<template>
    <div class="no-break">
        <div class="d-flex align-items-center mb-2">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" :id="id" v-model="isEnabled" @change="handleToggle">
                <label class="form-check-label" :for="id">
                    {{ title }}
                </label>
            </div>
        </div>

        <div v-if="isEnabled">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TimeTableSection',

    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        enabled: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            isEnabled: this.enabled
        };
    },

    methods: {
        handleToggle() {
            this.$emit('toggle', {
                id: this.id,
                enabled: this.isEnabled
            });
        }
    },

    watch: {
        enabled(newValue) {
            this.isEnabled = newValue;
        }
    }
};
</script>

<style scoped>
.form-check {
    margin-bottom: 0;
}

.form-check-label {
    font-weight: bold;
    color: #4bacc6;
    font-size: 14px;
    text-transform: uppercase;
}

.no-break { 
    break-inside: avoid; 
}
</style> 